import { render, staticRenderFns } from "./ActivateTenancyModal.vue?vue&type=template&id=38a27a28&scoped=true"
import script from "./ActivateTenancyModal.vue?vue&type=script&lang=js"
export * from "./ActivateTenancyModal.vue?vue&type=script&lang=js"
import style0 from "./ActivateTenancyModal.vue?vue&type=style&index=0&id=38a27a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a27a28",
  null
  
)

export default component.exports